import type { DocCategoryNode } from "@/lib/document/categoryTypes";

export type DocCategoryOption = {
  id: string;
  name: string;
  depth: number;
  is_system_default: boolean;
  parent_id: string | null;
};

/** Flatten the category tree for selects and sibling sort_order math. */
export function flattenDocCategoryTree(
  nodes: DocCategoryNode[],
  depth = 0,
): DocCategoryOption[] {
  const out: DocCategoryOption[] = [];
  for (const node of nodes) {
    out.push({
      id: node.id,
      name: node.name,
      depth,
      is_system_default: node.is_system_default,
      parent_id: node.parent_id,
    });
    if (node.children.length > 0) {
      out.push(...flattenDocCategoryTree(node.children, depth + 1));
    }
  }
  return out;
}

export function formatDocCategoryLabel(name: string, depth: number): string {
  if (depth <= 0) return name;
  return `${"— ".repeat(depth)}${name}`;
}

/** Next sort_order for a new sibling under the same parent. */
export function nextDocCategorySortOrder(
  flat: Omit<DocCategoryNode, "children">[],
  parentId: string | null,
): number {
  const siblings = flat.filter((c) => (c.parent_id ?? null) === parentId);
  if (siblings.length === 0) return 10;
  const max = Math.max(...siblings.map((c) => c.sort_order));
  return max + 10;
}

export function findDocCategoryNode(
  nodes: DocCategoryNode[],
  id: string,
): DocCategoryNode | null {
  for (const node of nodes) {
    if (node.id === id) return node;
    const child = findDocCategoryNode(node.children, id);
    if (child) return child;
  }
  return null;
}
